
/* ============================================================
   quick-add-size.js — v7
   Adds atc-btn toggle: click shows size grid, size click adds
   to cart and collapses back. Click outside also collapses.
   All v6 cart/drawer logic preserved unchanged.
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     SIZE GRID TOGGLE
  ---------------------------------------------------------- */

  function openSizes(wrap) {
    wrap.classList.add('qas-sizes-open');
    var sizesEl = wrap.querySelector('.qas-sizes');
    var atcBtn  = wrap.querySelector('.atc-btn');
    if (sizesEl) {
      sizesEl.setAttribute('aria-hidden', 'false');
      // Make size buttons focusable
      sizesEl.querySelectorAll('.qas-size').forEach(function (b) {
        b.removeAttribute('tabindex');
      });
    }
    if (atcBtn) atcBtn.setAttribute('aria-expanded', 'true');
  }

  function closeSizes(wrap) {
    wrap.classList.remove('qas-sizes-open');
    var sizesEl = wrap.querySelector('.qas-sizes');
    var atcBtn  = wrap.querySelector('.atc-btn');
    if (sizesEl) {
      sizesEl.setAttribute('aria-hidden', 'true');
      sizesEl.querySelectorAll('.qas-size').forEach(function (b) {
        b.setAttribute('tabindex', '-1');
      });
    }
    if (atcBtn) atcBtn.setAttribute('aria-expanded', 'false');
  }

  // Close all open size grids except optionally one
  function closeAllSizes(exceptWrap) {
    document.querySelectorAll('.qas-wrap.qas-sizes-open').forEach(function (wrap) {
      if (wrap !== exceptWrap) closeSizes(wrap);
    });
  }

  // Click outside → collapse
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.qas-wrap')) {
      closeAllSizes(null);
    }
  }, true); // capture phase so it fires before the click handlers below

  // Mouse leaves card → collapse
  // document.addEventListener('mouseleave', function (e) {
  //   var card = e.target.closest('.card__picture-container');
  //   if (card) {
  //     var wrap = card.querySelector('.qas-wrap');
  //     if (wrap) closeSizes(wrap);
  //   }
  // }, true);

  /* ----------------------------------------------------------
     CART / DRAWER HELPERS (v6 — unchanged)
  ---------------------------------------------------------- */

  function getCartDrawerSectionId() {
    var el = document.querySelector('cart-drawer[data-section-id], [data-section-id="cart-drawer"]');
    if (el && el.dataset.sectionId) return el.dataset.sectionId;
    return 'cart-drawer';
  }

  function isCartCurrentlyEmpty() {
    return document.querySelector('cart-drawer')?.classList.contains('wt-cart--empty')
      || !document.querySelector('.wt-cart__drawer__footer');
  }

  var _badgeTimer = null;
  function scheduleBadgeUpdate(itemCount) {
    clearTimeout(_badgeTimer);
    _badgeTimer = setTimeout(function () {
      if (typeof itemCount !== 'undefined') {
        document.querySelectorAll(
          '[data-cart-count], .cart-count, #cart-count, .js-cart-count, .wt-cart__count'
        ).forEach(function (el) { el.textContent = itemCount; });
      }
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll(
            '[data-cart-count], .cart-count, #cart-count, .js-cart-count, .wt-cart__count'
          ).forEach(function (el) { el.textContent = c.item_count; });
        })
        .catch(function () {});
    }, 600);
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    var toggleSelectors = [
      '[data-cart-drawer-toggle]', '[data-action="open-cart"]',
      '.js-cart-open', '#cart-icon-bubble', '[aria-controls="CartDrawer"]',
    ];
    for (var i = 0; i < toggleSelectors.length; i++) {
      var btn = document.querySelector(toggleSelectors[i]);
      if (btn) { btn.click(); break; }
    }
    var drawerSelectors = ['#CartDrawer', '[data-cart-drawer]', '.cart-drawer', '#cart-notification'];
    for (var j = 0; j < drawerSelectors.length; j++) {
      var drawer = document.querySelector(drawerSelectors[j]);
      if (drawer) {
        drawer.removeAttribute('hidden');
        drawer.setAttribute('aria-hidden', 'false');
        drawer.classList.add('is-open', 'active', 'open', 'wt-cart__drawer--open');
        break;
      }
    }
  }

  function buildItemHtml(item, index) {
    var imgHtml = item.image
      ? '<img class="card__img" src="' + item.image + '" alt="" loading="lazy" width="120" height="160">'
      : '';
    var optionsHtml = item.options_with_values.map(function (opt) {
      return '<div class="product-option"><span class="label">' + opt.name + ': </span>'
           + '<span class="value">' + opt.value + '</span></div>';
    }).join('');
    var price = (item.final_line_price / 100).toFixed(2);
    return [
      '<li id="CartDrawer-Item-' + index + '" class="cart-item wt-cart__item">',
      '  <picture class="wt-cart__item__thumb"><a href="' + item.url + '" class="wt-cart__item__link" tabindex="0">' + imgHtml + '</a></picture>',
      '  <div class="wt-cart__item__body">',
      '    <div class="wt-cart__item__data">',
      '      <h2 class="wt-cart__item__name cart-item__name"><a href="' + item.url + '" class="wt-cart__item__link" tabindex="0">' + item.product_title + '</a></h2>',
      '      <cart-remove-button id="CartDrawer-Remove-' + index + '" data-index="' + index + '">',
      '        <a class="wt-cart__item__remove wt-cart__item__remove--title" href="/cart/change?line=' + index + '&quantity=0" role="button" aria-label="Remove ' + item.product_title + '" tabindex="0">',
      '          <svg class="svg-icon svg-icon--bin " aria-hidden="true" id="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" data-icon-theme="option_4" width="72" height="72" viewBox="0 0 72 72"><g><path stroke="null" id="trash-alt" d="m58.55199,15.95408l-10.85873,0l-3.50748,-4.69075a5.01211,5.01211 0 0 0 -4.01068,-1.99289l-8.35268,0a5.01211,5.01211 0 0 0 -4.01566,1.99289l-3.5025,4.69075l-10.85873,0a0.83452,0.83452 0 0 0 -0.83452,0.83452l0,1.67153a0.83452,0.83452 0 0 0 0.83452,0.83452l2.50605,0l0,38.42283a5.01211,5.01211 0 0 0 5.01211,5.01211l30.07264,0a5.01211,5.01211 0 0 0 5.01211,-5.01211l0,-38.42283l2.50605,0a0.83452,0.83452 0 0 0 0.83452,-0.83452l0,-1.67153a0.83452,0.83452 0 0 0 -0.83701,-0.83452zm-28.06481,-2.67296a1.6815,1.6815 0 0 1 1.33772,-0.66762l8.35268,0a1.6815,1.6815 0 0 1 1.33772,0.66762l1.99289,2.67296l-15.02635,0l2.00534,-2.67296zm22.23063,44.43636a1.67153,1.67153 0 0 1 -1.67153,1.67153l-30.0826,0a1.67153,1.67153 0 0 1 -1.67153,-1.67153l0,-38.42283l33.42567,0l0,38.42283z"></path></g></svg>',
      '        </a>',
      '      </cart-remove-button>',
      '      <div class="options">' + optionsHtml + '</div>',
      '    </div>',
      '    <div class="wt-cart__item__amount cart-page">',
      '      <div class="item__details">',
      '        <quantity-counter class="counter-wrapper" data-cart="true"><div class="counter">',
      '          <button type="button" class="js-counter-decrease js-counter-button" aria-label="Decrease quantity for ' + item.product_title + '" tabindex="0"><svg class="svg-icon svg-icon--minus" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 72 72"><rect width="54" height="4" rx="2" y="34" x="9"/></svg></button>',
      '          <input class="js-counter-quantity" data-quantity-variant-id="' + item.variant_id + '" name="updates[]" value="' + item.quantity + '" data-cart-quantity="' + item.quantity + '" min="1" step="1" aria-label="Counter quantity" id="Drawer-quantity-' + index + '" data-index="' + index + '" tabindex="0">',
      '          <button type="button" class="js-counter-increase js-counter-button" aria-label="Increase quantity for ' + item.product_title + '" tabindex="0"><svg class="svg-icon svg-icon--plus" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 72 72"><rect width="54" height="4" rx="2" y="34" x="9"/><rect width="4" height="54" rx="2" y="9" x="34"/></svg></button>',
      '        </div></quantity-counter>',
      '        <cart-remove-button id="CartDrawer-Remove-' + index + '-amt" data-index="' + index + '">',
      '          <a class="wt-cart__item__remove wt-cart__item__remove--amount" href="/cart/change?line=' + index + '&quantity=0" role="button" aria-label="Remove ' + item.product_title + '" tabindex="0">',
      '            <svg class="svg-icon svg-icon--bin " aria-hidden="true" id="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" data-icon-theme="option_4" width="72" height="72" viewBox="0 0 72 72"><g><path stroke="null" id="trash-alt" d="m58.55199,15.95408l-10.85873,0l-3.50748,-4.69075a5.01211,5.01211 0 0 0 -4.01068,-1.99289l-8.35268,0a5.01211,5.01211 0 0 0 -4.01566,1.99289l-3.5025,4.69075l-10.85873,0a0.83452,0.83452 0 0 0 -0.83452,0.83452l0,1.67153a0.83452,0.83452 0 0 0 0.83452,0.83452l2.50605,0l0,38.42283a5.01211,5.01211 0 0 0 5.01211,5.01211l30.07264,0a5.01211,5.01211 0 0 0 5.01211,-5.01211l0,-38.42283l2.50605,0a0.83452,0.83452 0 0 0 0.83452,-0.83452l0,-1.67153a0.83452,0.83452 0 0 0 -0.83701,-0.83452zm-28.06481,-2.67296a1.6815,1.6815 0 0 1 1.33772,-0.66762l8.35268,0a1.6815,1.6815 0 0 1 1.33772,0.66762l1.99289,2.67296l-15.02635,0l2.00534,-2.67296zm22.23063,44.43636a1.67153,1.67153 0 0 1 -1.67153,1.67153l-30.0826,0a1.67153,1.67153 0 0 1 -1.67153,-1.67153l0,-38.42283l33.42567,0l0,38.42283z"></path></g></svg>',
      '          </a>',
      '        </cart-remove-button>',
      '      </div>',
      '      <div class="wt-cart__item__price-wrapper"><span class="price price--end">Rs.' + price + '</span></div>',
      '    </div>',
      '  </div>',
      '</li>',
    ].join('\n');
  }

  async function injectSectionHtml(sectionId) {
    try {
      const res = await fetch('/?sections=' + sectionId, { cache: 'no-store' });
      if (!res.ok) return false;
      const data = await res.json();
      var html = data[sectionId];
      if (!html) return false;
      var parser = new DOMParser();
      var doc    = parser.parseFromString(html, 'text/html');
      var innerDrawer = document.querySelector('.wt-cart__drawer__inner');
      if (!innerDrawer) return false;
      var freshFooter = doc.querySelector('.wt-cart__drawer__footer');
      if (freshFooter) {
        var oldFooter = innerDrawer.querySelector('.wt-cart__drawer__footer');
        if (oldFooter) oldFooter.remove();
        innerDrawer.appendChild(freshFooter);
      }
      var freshShippingBar = doc.querySelector('.cart-free-shipping-bar, [data-free-shipping-bar]');
      var drawerBody = document.querySelector('.wt-cart__drawer__body');
      if (freshShippingBar && drawerBody && !drawerBody.querySelector('.cart-free-shipping-bar')) {
        drawerBody.insertBefore(freshShippingBar, drawerBody.firstChild);
      }
      return true;
    } catch (e) {
      console.warn('[quick-add-size] section inject failed:', e.message);
      return false;
    }
  }

  function updateDrawerItems(cart) {
    var itemsContainer = document.querySelector('#CartDrawer-CartItems');
    if (itemsContainer && cart.items.length > 0) {
      var listHtml = '<ul class="wt-cart__list">'
        + cart.items.map(function (item, i) { return buildItemHtml(item, i + 1); }).join('')
        + '</ul>'
        + '<p id="CartDrawer-LiveRegionText" class="visually-hidden" role="status"></p>'
        + '<p id="CartDrawer-LineItemStatus" class="visually-hidden" aria-hidden="true" role="status">Loading...</p>';
      itemsContainer.innerHTML = listHtml;
      itemsContainer.querySelectorAll('.js-counter-quantity[disabled]').forEach(function (el) {
        el.removeAttribute('disabled');
      });
    }
    var qtyEl = document.querySelector('#CartDrawer-TotalQty');
    if (qtyEl) qtyEl.innerHTML = 'Your cart <span>(' + cart.item_count + ')</span>';
    var subtotalEl = document.querySelector('.wt-cart__subtotal__value');
    if (subtotalEl) subtotalEl.textContent = 'Rs.' + (cart.total_price / 100).toFixed(2) + ' PKR';
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) cartDrawerEl.classList.remove('wt-cart--empty');
  }

  async function refreshDrawer(wasEmpty) {
    try {
      const cartRes = await fetch('/cart.js', { cache: 'no-store' });
      if (!cartRes.ok) return;
      const cart = await cartRes.json();
      if (wasEmpty) {
        var sectionId = getCartDrawerSectionId();
        await injectSectionHtml(sectionId);
      }
      updateDrawerItems(cart);
      scheduleBadgeUpdate(cart.item_count);
    } catch (e) {
      console.warn('[quick-add-size] refreshDrawer failed:', e.message);
    }
  }

  /* ----------------------------------------------------------
     addToCart
  ---------------------------------------------------------- */
  async function addToCart(variantId, btn, feedbackEl, wrap) {
    btn.classList.add('qas-size--loading');
    btn.setAttribute('aria-busy', 'true');
    feedbackEl.textContent = '';
    feedbackEl.className   = 'qas-feedback';

    var wasEmpty = isCartCurrentlyEmpty();

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart');
      }

      await res.json();

      // Collapse size grid back to atc-btn
      if (wrap) closeSizes(wrap);

      openCartDrawer();

      feedbackEl.textContent = 'Added!';
      feedbackEl.classList.add('qas-feedback--ok');

      refreshDrawer(wasEmpty);

    } catch (e) {
      feedbackEl.textContent = e.message || 'Error — please try again.';
      feedbackEl.classList.add('qas-feedback--error');
    } finally {
      btn.classList.remove('qas-size--loading');
      btn.removeAttribute('aria-busy');
      setTimeout(function () {
        feedbackEl.textContent = '';
        feedbackEl.className   = 'qas-feedback';
      }, 3000);
    }
  }

  /* ----------------------------------------------------------
     Event delegation
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {

    // 1. atc-btn click → open size grid
    var atcToggle = e.target.closest('.atc-btn');
    if (atcToggle) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = atcToggle.closest('.qas-wrap');
      if (!wrap) return;
      if (wrap.classList.contains('qas-sizes-open')) {
        closeSizes(wrap);
      } else {
        closeAllSizes(wrap); // close any other open grids
        openSizes(wrap);
      }
      return;
    }

    // 2. Size button click → add to cart
    var sizeBtn = e.target.closest('.qas-size:not(:disabled)');
    if (sizeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var wrap2 = sizeBtn.closest('.qas-wrap');
      var fb    = wrap2 ? wrap2.querySelector('.qas-feedback') : document.createElement('div');
      var varId = parseInt(sizeBtn.dataset.variantId, 10);
      if (varId) addToCart(varId, sizeBtn, fb, wrap2);
      return;
    }

    // 3. Single-variant ATC button
    var atcBtn = e.target.closest('.qas-btn--atc:not(:disabled)');
    if (atcBtn) {
      e.preventDefault();
      var wrap3  = atcBtn.closest('.qas-wrap');
      var fb3    = wrap3 ? wrap3.querySelector('.qas-feedback') : document.createElement('div');
      var varId3 = parseInt(atcBtn.dataset.variantId, 10);
      if (varId3) addToCart(varId3, atcBtn, fb3, null);
    }
  });

})();

